'use client';

import { usePathname } from 'next/navigation';
import Script from 'next/script';
import { Fragment } from 'react';
import { isProd } from '~/constants/environment';
import oneTrustScripts from '~/constants/oneTrust/oneTrustScripts';
import getOneTrustSiteId from '~/proxy-utils/getOneTrustSiteId';

export default function OneTrustScripts() {
  const pathname = usePathname();
  const site = oneTrustScripts[getOneTrustSiteId(pathname ?? '')];
  const dataDomainScript = site?.enabled
    ? isProd
      ? site.prod
      : site.uat
    : undefined;

  if (!dataDomainScript) {
    return null;
  }

  return (
    <Fragment key="onetrust-scripts">
      <Script
        data-testid="onetrust-header-script"
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        type="text/javascript"
        data-domain-script={dataDomainScript}
        strategy="beforeInteractive"
      />
      <Script
        id="onetrust-optanon-wrapper"
        strategy="beforeInteractive"
        dangerouslySetInnerHTML={{
          __html: 'function OptanonWrapper() {}'
        }}
      />
    </Fragment>
  );
}
